// Produktliste (rsce_produktList.html5)
//
// Die oberste Reihe der Kategorieseite soll sofort sichtbar sein statt
// erst beim Scrollen einzublenden - sie steht beim Aufruf schon im Bild.
const liste = document.querySelector('.mod_iso_productlist .product_list');

if (liste) {
    [].slice.call(liste.children, 0, 6).forEach((kachel) => {
        kachel.removeAttribute('data-aos');

        const bild = kachel.querySelector('img');

        if (bild) {
            bild.setAttribute('loading', 'eager');
            bild.setAttribute('fetchpriority', 'high');
        }

        const link = kachel.querySelector('a[data-aos]');

        if (link) {
            link.removeAttribute('data-aos');
        }
    });
}

